/**
 * ULID en el cliente.
 *
 * Esto no es un detalle de implementación: es el corazón del modo offline.
 * La empleada crea la limpieza y cada clip **sin cobertura**, así que el
 * identificador lo tiene que generar el móvil. Cuando vuelve la red, la cola
 * reenvía sin miedo: el servidor reconoce el mismo id y no duplica nada.
 *
 * Mismo alfabeto que el servidor (base32 de Crockford, sin I, L, O ni U) y
 * mismo formato que valida el dominio `ulid` de PostgreSQL, así que un id mal
 * formado se rechaza en la base y no llega a existir.
 */

const ALFABETO = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';
const PATRON = /^[0-7][0-9A-HJKMNP-TV-Z]{25}$/;

export function ulid(ms: number = Date.now()): string {
    let tiempo = '';
    let resto = ms;
    for (let i = 0; i < 10; i++) {
        tiempo = ALFABETO[resto % 32] + tiempo;
        resto = Math.floor(resto / 32);
    }

    const bytes = new Uint8Array(10);
    crypto.getRandomValues(bytes);

    let bits = '';
    for (const b of bytes) {
        bits += b.toString(2).padStart(8, '0');
    }

    let azar = '';
    for (let i = 0; i < 80; i += 5) {
        azar += ALFABETO[parseInt(bits.slice(i, i + 5), 2)];
    }

    return tiempo + azar;
}

export function esUlid(v: unknown): v is string {
    return typeof v === 'string' && v.length === 26 && PATRON.test(v);
}

/** Cuándo lo generó el móvil. Sirve para ordenar la cola sin depender del reloj del servidor. */
export function instanteDeUlid(id: string): Date | null {
    if (!esUlid(id)) {
        return null;
    }

    let ms = 0;
    for (let i = 0; i < 10; i++) {
        ms = ms * 32 + ALFABETO.indexOf(id[i] as string);
    }

    return new Date(ms);
}
